<pp-button
  ppStyle="secondary"
  ppSize="large"
  ppId="user_management_new_account_admin_button"
  (ppAction)="openAddAccountAdminModal()"
>
  {{ 'add_account_admin' | ppTranslate }}
</pp-button>
